/* === RESTYLIT — COMPENSAZIONE SCROLLBAR CORRETTA === */
/*
  Problema: aprendo un drawer (hamburger, carrello, ricerca) il tema mette sul <body>
  la classe .modal-show / .modal-showing, che in theme.css vale:

      overflow: hidden;
      padding-right: var(--scrollbar-width);

  Serve a compensare la scrollbar che sparisce quando si blocca lo scroll, così la
  pagina non sobbalza. Ma --scrollbar-width viene calcolata UNA VOLTA SOLA al DOMready
  (theme.js:477; il listener sul resize è commentato alla riga 478) e con la formula
  `window.innerWidth - document.body.clientWidth`.

  Dove si rompe: su un telefono (o in device mode) la scrollbar è in overlay e non
  occupa spazio. Se la variabile è rimasta a un valore positivo, all'apertura del menu
  non si recupera niente ma il padding viene aggiunto comunque: la pagina si stringe,
  scivola a sinistra e lascia una barra bianca a destra.
  Misurato a 408px: bordo destro 408 -> 393, barra bianca 15px.

  Qui la ricalcoliamo quando serve davvero e la azzeriamo quando non c'è niente da
  compensare. Due differenze dalla formula del tema:
  - si usa documentElement.clientWidth, non body.clientWidth: quest'ultimo risente del
    padding che stiamo per applicare, quindi rimisurare a lucchetto chiuso lo falserebbe;
  - il valore 0 viene scritto, non ignorato.
*/
(function () {
  var root = document.documentElement;
  var last = null;
  var LOCKED = /(^|\s)(modal-show|modal-showing|body-no-scrollbar)(\s|$)/;

  function measure() {
    // A lucchetto già chiuso la misura non è attendibile: si lascia il valore com'è.
    if (document.body && LOCKED.test(document.body.className)) return;

    var gap = window.innerWidth - root.clientWidth;
    var value = (gap > 0 ? gap : 0) + 'px';
    if (value === last) return; // evita un recalc di stile a ogni click
    last = value;
    root.style.setProperty('--scrollbar-width', value);
  }

  measure();
  document.addEventListener('DOMContentLoaded', measure);
  window.addEventListener('resize', measure);
  window.addEventListener('orientationchange', measure);

  /* In cattura, quindi prima che il tema apra il drawer: al momento del click il body
     non è ancora bloccato ed è l'istante giusto per misurare. */
  document.addEventListener('click', measure, true);
})();
